export default __webpack_public_path__ + "static/media/emoji-instagram.fee56260.svg";